import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable } from 'rxjs';
//import { PensionData } from '../../assets/data/seed/pensions.json'
import { IPension } from './../models/pension.model';
import pensions from '../../assets/data/seed/pensions.json';

@Injectable({
  providedIn: 'root'
})
export class PensionDataService {
  private messageSource = new BehaviorSubject(JSON.stringify(pensions));
  currentMessage:Observable<string> = this.messageSource.asObservable();
  
  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  async getMessage(){
    return await this.currentMessage.toPromise();
  }
  
}